import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import AllReviewers from './pages/AllReviewers';
import MyLibrary from './pages/MyLibrary';
import AccountSettings from './pages/AccountSettings';
import UpdateSubscription from './pages/UpdateSubscription';
import UpgradeToPremium from './pages/UpgradeToPremium';
import HelpCenter from './pages/HelpCenter';
import Announcement from './pages/Announcement';
import ExamDetails from './pages/ExamDetails';
import Exam from './pages/Exam';
import ExamResultsLoading from './pages/ExamResultsLoading';
import ExamReview from './pages/ExamReview';
import ShareResult from './pages/ShareResult';
import TrialAssessment from './pages/TrialAssessment';
import Dashboard from './pages/Dashboard';
import SprintTaskOverview from './pages/SprintTaskOverview';
import SprintTaskResult from './pages/SprintTaskResult';
import DashboardLayout from './components/DashboardLayout';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AOS_CONFIG } from './config/aos';

function TrialResultRedirect() {
  const { attemptId } = useParams();
  return <Navigate to={`/dashboard/results/${attemptId}`} replace />;
}

function App() {
  useEffect(() => {
    AOS.init(AOS_CONFIG);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/pricing/upgrade" element={<UpgradeToPremium />} />
        <Route path="/share/:shareToken" element={<ShareResult />} />

        {/* Trial assessment flow (shown once for new/existing users) */}
        <Route path="/trial" element={<ProtectedRoute skipTrialGate><TrialAssessment /></ProtectedRoute>} />
        <Route path="/trial/exam/:id" element={<ProtectedRoute skipTrialGate><Exam isTrial /></ProtectedRoute>} />
        <Route path="/trial/results/:attemptId" element={<TrialResultRedirect />} />

        {/* Protected dashboard routes — DashNav persists via DashboardLayout (mounts once, not per nav). */}
        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/all-reviewers" element={<AllReviewers />} />
          <Route path="/dashboard/library" element={<MyLibrary />} />
          <Route path="/dashboard/settings" element={<AccountSettings />} />
          <Route path="/dashboard/settings/update-subscription" element={<UpdateSubscription />} />
          <Route path="/dashboard/help" element={<HelpCenter />} />
          <Route path="/dashboard/announcements" element={<Announcement />} />
          <Route path="/dashboard/results/:attemptId" element={<ExamResultsLoading />} />
          <Route path="/dashboard/review/:attemptId" element={<ExamReview />} />
          <Route path="/dashboard/exam/:id" element={<ExamDetails />} />
          <Route path="/dashboard/sprint/task/:taskId/overview" element={<SprintTaskOverview />} />
          <Route path="/dashboard/sprint/task/:taskId/result" element={<SprintTaskResult />} />
          <Route path="/dashboard/sprint/task/:taskId/review" element={<ExamReview />} />
          <Route path="/dashboard/exam/:id/start" element={<Exam />} />
          <Route path="/dashboard/sprint/task/:taskId" element={<Exam />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
